export const enum TransactionType {
    FanToken = 'fan_token',
    Main = 'main'
}

export const enum TransactionBatchType {
    KycCumulativeLimit = 'kyc_cumulative_limit',
    Withdrawal = 'withdrawal',
    MarketplacePurchase = 'marketplace_purchase',
    Bonus = 'bonus',
    MarketplaceSale = 'marketplace_sale',
    Buy = 'buy',
    Deposit = 'deposit',
    RegulatoryRestriction = 'regulatory_restriction',
}

export const enum TransactionInternalType {
    Unlock = 'unlock',
}

export const enum TransactionAmountColor {
    Green = 'green',
    Amber = 'amber',
    Red = 'red',
}

export const enum TransactionDetailsFieldDataType {
    CurrencyAmount = 'currencyAmount',
    Amount = 'amount',
    Link = 'link',
    Date = 'date',
    DateTime = 'dateTime',
    Time = 'time',
    Text = 'text',
}

export interface TransactionsHistoryUrlParams {
    type: TransactionType;
}

export interface GetTransactions {
    type: TransactionType;
    page: number;
    limit: number;
    canAppend: boolean;
    filtersRequest?: Record<string, string>;
    currencyIds?: string[];
    latest?: boolean;
}

export interface SetTransactions {
    type: TransactionType;
    canAppend: boolean;
    transactions: FormattedTransaction[];
    pagination: PaginationMetadata;
}

export interface SetFormattedTransactions {
    type: TransactionType;
    canAppend: boolean;
    formattedTransactions: FormattedTransaction[];
    pagination: PaginationMetadata;
}

export interface TransactionsPagination {
    currentPage: number;
    lastPage: number;
    totalItems: number;
}

export interface TransactionsDetails {
    [x: string]: TransactionDetails;
}

export interface FormattedTransactionsDetails {
    [x: string]: FormattedTransactionDetails;
}

export interface FormattedTransaction extends Transaction {
    partnerLogo: string;
    logo: string;
    amountColor: TransactionAmountColor;
    formattedAmount: string;
    heading: string;
    showHeading: boolean;
    showDate: boolean;
    formattedStatus: string;
    formattedDate: string;
    status?: string;
}

export type Transactions = {
    [x in TransactionType]: Transaction[];
};

export type FormattedTransactions = {
    [x in TransactionType]: FormattedTransaction[];
};

export type TransactionDetailsSummary = {
    transactionId: string;
    transactionTypeName: string;
    amount: string;
    date: string;
    isNegativeBalance: boolean;
    currencySymbol: string;
    currencyShortCode: string;
    partnerId: string;
    isPending: boolean;
    currencyId: string;
    transactionBatchType: string;
    transactionType: string;
};

export type TransactionDetailsType = {
    title: string;
    fields: TransactionDetailsFields[];
};

export interface TransactionDetailsFields {
    label: string;
    dataType: TransactionDetailsFieldDataType;
    data: Record<string, never>;
    isCopyable: boolean;
    formattedValue?: string | number;
}

export interface TransactionDetailsRows {
    fields: TransactionDetailsFields[];
}

export interface TransactionDetailsSection {
    title: string;
    rows: TransactionDetailsRows[];
}

export interface TransactionDetails {
    id: string;
    summary: TransactionDetailsSummary;
    sections: TransactionDetailsSection[];
}

export interface FormattedTransactionDetails extends TransactionDetails {
    logo: string;
    logoPlaceholder: boolean;
    iconCode: string;
    iconColor: string;
    amountColor: TransactionAmountColor;
    headerAmount: string;
    headerTransactionTime: string;
}